import Custom404 from "pages/404";
import { getPageData, getGlobalData } from "utils/api";
import { getLocalizedPaths } from "utils/localize";
import {
  getSectionTitle,
  getSerializedSections,
} from "utils/strapi-serializer";

import { RefreshHeader } from "@/components/brandRefresh/common/PageTemplate";
import SeoJSON from "@/components/elements/seoJSON";
import Sections from "@/components/sections";

export default function slug({
  sections,
  metadata,
  global,
  versionsAvailable,
  version,
  preview,
}) {
  if (!sections?.length) {
    return <Custom404 global={global.data} />;
  }

  if (metadata?.metaImage?.data === null) {
    delete metadata?.metaImage;
  }

  return (
    <>
      <SeoJSON structuredData={metadata?.structuredData} />
      <RefreshHeader metadata={metadata}>
        <div className="flex flex-col text-sm md:text-base 4xl:text-xl">
          <Sections
            version={version}
            versionsAvailable={versionsAvailable}
            sections={sections}
            preview={preview}
          />
        </div>
      </RefreshHeader>
    </>
  );
}

export async function getServerSideProps(context) {
  const { params, locale, locales, defaultLocale, preview = null } = context;

  const globalLocale = await getGlobalData(locale);

  const pageData = await getPageData({
    slug: params?.slug?.[0] ?? "",
    locale,
    preview,
  });

  if (pageData === null) {
    return {
      props: {
        global: globalLocale,
      },
    };
  }

  // We have the required page data, pass it to the page component
  const versionsAvailable = preview
    ? pageData.map(v => {
        return v.attributes.versionNumber;
      })
    : null;
  const version = preview
    ? context.query.version === undefined
      ? versionsAvailable[pageData.length - 1]
      : context.query.version < 1
        ? versionsAvailable[pageData.length - 1]
        : +context.query.version
    : null;
  const filterData = preview
    ? pageData.filter(Data => Data.attributes.versionNumber === version)
    : null;
  const isLimit = preview ? filterData.length < 1 : false;
  if (isLimit) {
    return {
      props: {
        global: globalLocale,
      },
    };
  }

  const { contentSections, seo, localizations, slug, protectedPage } = preview
    ? filterData[0].attributes
    : pageData.attributes;

  const pageContext = {
    locale,
    locales,
    defaultLocale,
    slug,
    localizations,
    protectedPage,
  };

  const localizedPaths = getLocalizedPaths(pageContext);

  return {
    props: {
      preview,
      versionsAvailable,
      version,
      title: getSectionTitle(contentSections),
      sections: getSerializedSections(contentSections),
      metadata: seo,
      global: globalLocale.data,
      pageContext: {
        ...pageContext,
        localizedPaths,
      },
    },
  };
}
